import { Cores } from 'src/componentes/styles'
import { FormUnform } from 'src/componentes/unform/form'
import styled from 'styled-components'

export const Form = styled(FormUnform)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export const Campo = styled.div<{ largura?: string; alinhamento?: string }>`
  flex: ${({ largura }) => (largura ? `0 0 ${largura}` : '1')};
  max-width: ${({ largura }) => largura || '100%'};
  margin-right: 10px;
  ${({ alinhamento }) => alinhamento && `align-self: ${alinhamento};`}
`

export const Dados = styled.div`
  margin-top: 25px;
`

export const TextoConfirmacaoModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const CalloutAlertaModal = styled.p`
  border: 1px solid ${Cores.PERIGO_ERRO};
  background: ${Cores.PERIGO_ERRO_FUNDO_MAIS_CLARO};
  border-radius: 4px;
  padding: 12px 16px;
  margin: 0;
`

export const Tabela = styled.table`
  margin: 20px 0 27px 0;
  font-family: 'Saira', sans-serif;
  font-size: 12px;
  color: #191414;
  border-collapse: collapse;
  border: 1px solid ${Cores.CINZA_3_CLARO};
  width: 100%;

  th {
    background: ${Cores.CINZA_HEAD_TABLE};
    color: ${Cores.PRETO};
    font-family: 'Saira-Semi-Bold', sans-serif;
    font-weight: 600;
    font-size: 14px;
    padding: 12px;
    border-bottom: none;
    text-transform: uppercase;
  }

  th:first-child {
    border-top-left-radius: 8px;
  }

  th:last-child {
    border-top-right-radius: 8px;
  }

  tbody {
    line-height: 125%;

    tr:first-child {
      border-top: 2px solid ${Cores.CINZA_3_CLARO};
    }

    tr {
      height: 48px;
      border: 1px solid ${Cores.FUNDO};
      border-bottom: none;

      &:last-child {
        border-bottom: 1px solid ${Cores.FUNDO};
      }

      &.par {
        background: ${Cores.FUNDO};
      }

      &.marcado {
        background: #afc2ed;
        border: 1px solid ${Cores.PRIMARIA_2_ESCURO};
      }

      &.comMarcacao {
        cursor: pointer;
      }

      td,
      th {
        padding: 0 12px;
      }

      &:hover {
        border: 1px solid ${Cores.SECUNDARIA_1};
      }
    }
  }
`
